import React from 'react';
import { HOME_CARD_ICONS } from '../../../../constants/defaultValues';
import styles from './CardIcon.module.scss';

const Icon = ({ iconName }) => {
    const HomeIcon = HOME_CARD_ICONS[iconName];

    return HomeIcon ? <HomeIcon className={styles.cardIcon} /> : null;
};

export default Icon;
